import { createSlice } from "@reduxjs/toolkit";

const DateSlice=createSlice({
    name:"DateSlice",
    initialState:[],
    reducers:{
        ChangeSinceDate(state,action){  
            state.length=0          
            state.push(action.payload)
            // state=action.payload
            // return
        },
    }
})

export {DateSlice}

export const {ChangeSinceDate}=DateSlice.actions